import { BoxProps } from '@jfs/ui-new'
import { Colors } from './../../util/util'

export const styles = {
  modalContainer: {
    flex: 1,
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.MODAL_SHADOW,
    zIndex: 1,
  } as BoxProps,
  calendarContainer: {
    paddingTop: 4,
    backgroundColor: 'WHITE',
    borderRadius: 8,
  } as BoxProps,
  selectionContiner: {
    backgroundColor: 'WHITE',
    alignSelf: 'flex-start',
    marginLeft: 26,
    display: 'none',
  } as BoxProps,
  labelContainer: {
    alignSelf: 'center',
    marginLeft: 12,
    paddingTop: 12,
    paddingBottom: 8,
  } as BoxProps,
  scrollVIewStyle: {
    maxHeight: 370,
  } as BoxProps,
}
